import request from '@/utils/superagent'
import APIS from '../apis'
import {
  removeUserInfoFromLocalStorage,
  removeProductFromSessionStorage
} from '@/utils/auth'
import { getStringByTextKey } from '@/utils/getStringByTextKey'

export default {
  fasooLogin: async function({ otpToken, otp }) {
    return new Promise((resolve, reject) => {
      request(
        APIS.SESSIONS.FASOO_LOGIN.method,
        APIS.SESSIONS.FASOO_LOGIN.path()
      )
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .withCredentials()
        .send({
          otpToken,
          otp
        })
        .end((err, res) => {
          if (err) {
            if (res) {
              reject(res.body)
            } else {
              alert(getStringByTextKey('common.alert.internetConnect'))
            }
          } else {
            resolve(res.body)
          }
        })
    })
  },

  fasooLoginCheck: async function({ userId, password }) {
    return new Promise((resolve, reject) => {
      request(
        APIS.SESSIONS.FASOO_LOGIN_CHECK.method,
        APIS.SESSIONS.FASOO_LOGIN_CHECK.path()
      )
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .withCredentials()
        .send({
          userId: userId,
          password: password
        })
        .end((err, res) => {
          if (err) {
            if (res) {
              reject(res.body)
            } else {
              alert(getStringByTextKey('common.alert.internetConnect'))
            }
          } else {
            resolve(res.body)
          }
        })
    })
  },

  fasooLoginOtp: async function(otpToken) {
    return new Promise((resolve, reject) => {
      request(
        APIS.SESSIONS.FASOO_LOGIN_OTP.method,
        APIS.SESSIONS.FASOO_LOGIN_OTP.path()
      )
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .withCredentials()
        .send({ otpToken })
        .end((err, res) => {
          if (err) {
            if (res) {
              reject(res.body)
            } else {
              alert(getStringByTextKey('common.alert.internetConnect'))
            }
          } else {
            resolve(res.body)
          }
        })
    })
  },

  logout: async function(remainProduct) {
    return new Promise((resolve, reject) => {
      request(APIS.SESSIONS.LOGOUT.method, APIS.SESSIONS.LOGOUT.path()).end(
        (err, res) => {
          removeUserInfoFromLocalStorage()
          if (!remainProduct) removeProductFromSessionStorage()
          if (err) {
            console.log(err)
            reject(err)
          } else {
            resolve()
          }
        }
      )
    })
  },

  join: async function(userId, userName, userPwd, token, companyName) {
    return new Promise((resolve, reject) => {
      request(APIS.SESSIONS.JOIN.method, APIS.SESSIONS.JOIN.path())
        .withCredentials()
        .send({ userId, userName, userPwd, token, companyName })
        .end((err, res) => {
          if (err) {
            if (res) {
              reject(res.body)
            } else {
              alert(getStringByTextKey('common.alert.internetConnect'))
            }
          } else {
            resolve(res.body)
          }
        })
    })
  },

  sendToken: async function(userId) {
    return new Promise((resolve, reject) => {
      request(APIS.SESSIONS.SEND_TOKEN.method, APIS.SESSIONS.SEND_TOKEN.path())
        .withCredentials()
        .send({ userId })
        .end((err, res) => {
          if (err) {
            if (res) {
              reject(res.body)
            } else {
              alert(getStringByTextKey('common.alert.internetConnect'))
            }
          } else {
            resolve(res.body)
          }
        })
    })
  },

  login: async function({ userId, password }) {
    return new Promise((resolve, reject) => {
      request(APIS.SESSIONS.LOGIN.method, APIS.SESSIONS.LOGIN.path())
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .withCredentials()
        .send({
          userId: userId,
          password: password
        })
        .end((err, res) => {
          if (err) {
            if (res) {
              reject(res.body)
            } else {
              alert(getStringByTextKey('common.alert.internetConnect'))
            }
          } else {
            resolve(res.body)
          }
        })
    })
  },

  passwordInit: async function({ forgetUserId, forgetUserName }) {
    return new Promise((resolve, reject) => {
      request(APIS.PAPI.PASSWORD_INIT.method, APIS.PAPI.PASSWORD_INIT.path())
        .send({
          userId: forgetUserId,
          userName: forgetUserName
        })
        .end((err, res) => {
          if (err) {
            if (res) {
              reject(res.body)
            } else {
              alert(getStringByTextKey('common.alert.internetConnect'))
            }
          } else {
            resolve(res.body)
          }
        })
    })
  },

  checkUserId: async function(userId) {
    return new Promise((resolve, reject) => {
      request(
        APIS.SESSIONS.CHECK_USERID.method,
        APIS.SESSIONS.CHECK_USERID.path()
      )
        .send({ userId })
        .end((err, res) => {
          if (err && res) {
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },

  withdrawal: async function(userId) {
    return new Promise((resolve, reject) => {
      request(APIS.SESSIONS.WITHDRAWAL.method, APIS.SESSIONS.WITHDRAWAL.path())
        .send({ userId })
        .end((err, res) => {
          if (err) {
            if (res) {
              reject(res.body)
            } else {
              alert(getStringByTextKey('common.alert.internetConnect'))
            }
          } else {
            resolve(res.body)
          }
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Auth.js